var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { FrontPage } from '../../twig/pages/front-page';
import { Masks } from '../../twig/components/Masks';
export class Navigator extends Component {
    constructor(isDebugEnabled = false) {
        super('Navigator', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            Navigator.siteURL = window.location.origin;
            if ('scrollRestoration' in history)
                history.scrollRestoration = 'manual';
            $(window).on('popstate', (event) => {
                let state = event.state;
                if (!state) {
                    state = {
                        navigationType: 'scroll',
                        projectIndex: 0,
                        url: window.location.pathname
                    };
                }
                Navigator.handleNavigation(state);
            });
            this.success();
        });
    }
    static navigate(url, type, projectIndex, slideIndex, transition) {
        url = url.replace(Navigator.siteURL, '');
        if (url === '')
            url = '/';
        const data = {
            url: url,
            navigationType: type,
            projectIndex: projectIndex !== undefined ? projectIndex : null,
            slideIndex: slideIndex !== undefined ? slideIndex : null,
            transition: transition !== undefined ? transition : true
        };
        history.pushState(data, '', url);
        Navigator.handleNavigation(data);
    }
    static handleNavigation(data) {
        if (data.navigationType === 'scroll' && data.projectIndex !== null) {
            $('.btn-toggle-menu').removeClass('is-active');
            $('#dynamic-page').removeClass('is-open');
            $('#dynamic-page-content').addClass('d-none').empty();
            $('.project-informations').addClass('d-none');
            FrontPage.scrollTo(data.projectIndex, data.slideIndex, data.transition);
        }
        else if (data.navigationType === 'link') {
            $('.btn-toggle-menu').addClass('is-active');
            $('#dynamic-page').addClass('is-open');
            Navigator.loadContent(data.url);
        }
    }
    static loadContent(url) {
        return __awaiter(this, void 0, void 0, function* () {
            $('#dynamic-page-content').removeClass('d-none').empty();
            $('#dynamic-page-spinner').removeClass('d-none');
            const response = yield $.httpRequest({
                url: url,
                type: 'POST',
                body: {
                    'load_async': true,
                },
                dataType: 'html'
            });
            $('#dynamic-page-content').append(response);
            $('#dynamic-page-spinner').addClass('d-none');
            Masks.applyBottomMask();
        });
    }
}
